import { ReelWildParticlesLandscapeProperties } from "../landscape/ReelWildParticlesLandscapeProperties";
export class ReelWildParticlesPortraitProperties extends ReelWildParticlesLandscapeProperties {
    constructor() {
        super();
        this.position.set(11, 364); //values from the GameTicket
        this.scale.set(1 / 0.73);
    }
}
//# sourceMappingURL=ReelWildParticlesPortraitProperties.js.map